export default "__VITE_ASSET__Dsz7eTEc__"